const SecurityIcon = ({ ...props }) => {
  return (
    <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle opacity='0.15' cx='15' cy='15' r='15' fill='#8B8E9F' />
      <path
        d='M15 14.6945C14.6161 14.6945 14.248 14.542 13.9766 14.2706C13.7052 13.9991 13.5527 13.631 13.5527 13.2471C13.5527 12.8633 13.7052 12.4951 13.9766 12.2237C14.248 11.9523 14.6161 11.7998 15 11.7998C15.3839 11.7998 15.7522 11.9523 16.0237 12.2238C16.2951 12.4953 16.4477 12.8635 16.4477 13.2475C16.4477 13.6314 16.2951 13.9996 16.0237 14.2711C15.7522 14.5426 15.3839 14.6951 15 14.6951V16.8658'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.7814 14.9267V11.4067C20.7815 11.1366 20.6966 10.8733 20.5387 10.6541C20.3807 10.435 20.1577 10.2712 19.9014 10.186L16.6254 9.09337C15.5696 8.74622 14.4304 8.74622 13.3747 9.09337L10.0987 10.1854C9.84239 10.2704 9.61942 10.4341 9.46145 10.6531C9.30348 10.8721 9.21853 11.1353 9.21869 11.4054V14.9254C9.21874 15.7943 9.4391 16.649 9.85917 17.4096C10.2792 18.1702 10.8853 18.8119 11.6207 19.2747L14.3194 20.9707C14.5235 21.0982 14.7593 21.1658 15 21.1658C15.2407 21.1658 15.4766 21.0982 15.6807 20.9707L18.3787 19.2747C19.1142 18.8121 19.7203 18.1705 20.1405 17.41C20.5607 16.6495 20.7812 15.7949 20.7814 14.926'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default SecurityIcon;
